import { tr } from 'i18n';
/**
 * Получает текущую геопозицию через navigator.geolocation
 * Возвращает строку "lat,lng" или бросает ошибку
 */
export const getCurrentGeoPosition = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error(tr("Геолокация не поддерживается")));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve(`${pos.coords.latitude},${pos.coords.longitude}`),
      (err) => reject(err),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  });
};
